
import { Fancybox } from "@fancyapps/ui";

async function createVideoThumbnail(src: string, seekTo = 0.1): Promise<string> {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");

        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;
        video.src = src;

        video.addEventListener("loadeddata", () => {
            if (video.readyState < 2) return;
            video.currentTime = Math.min(seekTo, Math.max(0, video.duration || seekTo));
        });

        video.addEventListener("seeked", () => {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth || 320;
            canvas.height = video.videoHeight || 180;

            const ctx = canvas.getContext("2d");
            if (!ctx) {
                reject(new Error("Canvas context not available"));
                return;
            }

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL("image/jpeg", 0.8));
        });

        video.addEventListener("error", () => {
            reject(new Error(`Thumbnail generation failed for ${src}`));
        });
    });
}

async function prepareVideoThumbs() {
    const items = Array.from(
        document.querySelectorAll<HTMLAnchorElement>('[data-fancybox="video2"]')
    );

    await Promise.all(
        items.map(async (item) => {
            const src = item.getAttribute("href");

            if (!src || item.dataset.thumbSrc) return;

            try {
                const thumb = await createVideoThumbnail(src, 0.15);
                item.setAttribute("data-thumb-src", thumb);
            } catch (e) {
                console.warn("Thumb generation error:", src, e);
            }
        })
    );
}

export async function initFancybox() {
    await prepareVideoThumbs();
    Fancybox.bind("[data-fancybox]", {
        infinite: true,
        loop: true,
        buttons: ["zoom", "close"],
        on: {
            reveal: (fancybox, slide) => {
                if (slide.src?.endsWith(".mp4")) {
                    slide.type = "html";
                    slide.src = `<video class="fancybox__html5video" playsinline controls muted style="width:100%">
                        <source src="${slide.src}" type="video/mp4">
                     </video>`;
                }
            },
            done: (fancybox, slide) => {
                if (slide.type === "html") {
                    // Видео вставлено в DOM, но Fancybox может ещё не отрендерить
                    setTimeout(() => {
                        const videoEl = slide.contentEl?.querySelector<HTMLVideoElement>('video');
                        videoEl.play().catch(() => {
                            // если play() не сработал, попробуем клик
                            videoEl.dispatchEvent(new Event('click'));
                        });
                    }, 1000); // небольшая задержка, чтобы видео вставилось
                }
            }
        }
    });
    Fancybox.bind('[data-fancybox="video2"]', {
        infinite: true,
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["thumbs", "close"]
            }
        },
        Carousel: {
            Thumbs: {
                type: "classic",
                showOnStart: true
            }
        },
        on: {
            reveal: (fancybox, slide) => {
                const trigger = slide.triggerEl as HTMLAnchorElement | undefined;
                const src = trigger?.getAttribute("href");

                if (src?.match(/\.(mp4|webm)$/i)) {
                    slide.type = "html";
                    slide.src = `
                        <video
                            class="fancybox__html5video"
                            playsinline
                            controls
                            autoplay
                            muted
                            preload="metadata"
                            style="width:100%;height:auto;display:block;"
                        >
                            <source src="${src}" type="video/mp4">
                        </video>
                    `;
                }
            },

            done: (fancybox, slide) => {
                const currentVideo =
                    slide.contentEl?.querySelector<HTMLVideoElement>("video");

                currentVideo?.play().catch(() => {});
            },

            "Carousel.change": (fancybox) => {
                const currentVideo =
                    fancybox.getSlide()?.contentEl?.querySelector("video");

                document
                    .querySelectorAll(".fancybox__container video")
                    .forEach((video) => {
                        if (video !== currentVideo) {
                            (video as HTMLVideoElement).pause();
                        }
                    });
            }
        }
    });
}